<template>
  <tr class="email-template-row">
    <td>
      {{ emailTemplate.name }}
    </td>
    <td>
      <p v-for="email in emailTemplate.ccAddress">
        {{ email }}
      </p>
    </td>
    <td>
      <p v-for="email in emailTemplate.bccAddress">
        {{ email }}
      </p>
    </td>
    <td>
      <router-link class="btn btn-primary btn-sm"
      :to="{ path: `/membership/emails/edit/${emailTemplate.uuid}` }">
        <span class="fa fa-edit fa-fw"></span> Edit
      </router-link>
    </td>
    <td>
      <button class="btn btn-success btn-sm" type="button" @click="preview()">
        <span class="fa fa-search"></span> Preview
      </button>
    </td>
  </tr>
</template>

<script>
import Api from '@/vuex/api'
import { OPEN_MODAL } from '@/vuex/types'
export default {
  name: 'EmailTemplateRow',
  props: {
    object: {
      type: Object
    },
    index: {
      type: Number
    }
  },
  computed: {
    emailTemplate () {
      return {
        ...this.object
      }
    }
  },
  methods: {
    async preview () {
      let api = new Api()
      let html = await api.compileEmailTemplate(this.emailTemplate.content)
      let previewModal = {
        title: 'Email Template Preview',
        html,
        options: {
          useiFrame: true
        }
      }
      this.$store.dispatch(OPEN_MODAL, previewModal)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/rows/EmailTemplate.vue